import { VorgangsTyp } from './vorgangsTyp';
import { Zuweisung } from './zuweisung';
import { Organisation } from '../../service/organisation/organisation';
import { ErinnerungsMail } from './erinnerungsmail';

// ex: template model
export class Aufgabe {
    id: number; // set backend only
    name: string; // user choice
    frist: string; // user choice
    hatDokument: boolean; // set backend only
    istBatch: boolean;
    mitUenbTeilen: boolean; // only relevant for erstelle-aufgabe-dialog
    emailBenachrichtigungSenden: boolean; // auto choice user input
    emailBenachrichtigungNachVorgangabschluss: boolean; // auto choice user input
    kurzbeschreibung: string;// user choice
    ersteller: Organisation; // set backend only
    type: VorgangsTyp; // user choice
    zuweisungen: Zuweisung[] = []; // user choice through files / semi auto
    erstellungsDatum: string; // set backend only
    erinnerungsMail: ErinnerungsMail; // auto set
}
